import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../services/api.service';
import * as _ from 'lodash';
import { HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
var LinkCodeComponent = (function () {
    function LinkCodeComponent(modalService, apiService, translate) {
        this.modalService = modalService;
        this.apiService = apiService;
        this.translate = translate;
        this.cust_list = [];
        this.delivery_email = [];
        this.delivery_cc = [];
        this.delivery_tel = [];
        this.loading = false;
        this.loading_main = false;
        this.totalItems = 0;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.showlist = [];
        this.addrlist_of_selected_cust = [];
        this.addrlist_without_cust = [];
        this.Delivery = [];
        this.data = [];
        this.keep_email = [];
        this.keep_cc = [];
        this.keep_tel = [];
        this.loadinput = [];
        this.delivery_email_update = [];
        this.delivery_email_updatedata = [];
        this.delivery_cc_update = [];
        this.delivery_cc_updatedata = [];
        this.delivery_tel_update = [];
        this.delivery_tel_updatedata = [];
        this.files = [];
    }
    LinkCodeComponent.prototype.ngOnInit = function () {
        this.selectedAddr = null;
        this.loadCustomerList();
        this.loadInput();
    };
    LinkCodeComponent.prototype.filesDropped = function (files) {
        // this.files = files;
        this.keepexcel = [];
        this.keepexcel.push(files[0].file);
    };
    LinkCodeComponent.prototype.loadCustomerList = function (page) {
        var _this = this;
        this.selectedAddr = null;
        this.cust_list = [];
        this.loading_main = true;
        var params = new HttpParams();
        if (this.searchdelivery) {
            params = params.append('search', this.searchdelivery);
        }
        if (this.searchcustcode) {
            params = params.append('id', this.searchcustcode);
        }
        if (this.searchcustcode == null && this.searchdelivery == null) {
            params = params.append('page', this.currentPage.toString());
            params = params.append('page_size', this.itemsPerPage.toString());
        }
        this.apiService.getCustomerList(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.totalItems = result.count;
                _this.cust_list.push({
                    label: obj.c_code,
                    name: obj.c_name,
                    value: obj.id,
                    contact_name: obj.c_contact_name,
                    delivery: [_this.data],
                    keepdelivery: obj.delivery_codes
                });
            });
            _this.loading_main = false;
            _this.updateRowGroupMetaData();
        });
    };
    LinkCodeComponent.prototype.loadInput = function () {
        var _this = this;
        this.loadinput = [];
        this.loading_main = true;
        var params = new HttpParams();
        params = params.append('none_pagination', 'true');
        this.apiService.getCustomerList(params).subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.loadinput.push({
                    label: obj.c_code,
                    name: obj.c_name,
                    value: obj.id,
                    contact_name: obj.c_contact_name,
                    delivery: [_this.data]
                });
                _this.loading_main = false;
            });
            _this.updateRowGroupMetaData();
        });
    };
    LinkCodeComponent.prototype.updateRowGroupMetaData = function () {
        this.rowGroupMetadata = {};
        if (this.cust_list) {
            for (var i = 0; i < this.cust_list.length; i++) {
                var rowData = this.cust_list[i];
                var value = rowData.value;
                if (i == 0) {
                    this.rowGroupMetadata[value] = { index: 0, size: 1 };
                }
                else {
                    var previousRowData = this.cust_list[i - 1];
                    var previousRowGroup = previousRowData.value;
                    if (value === previousRowGroup)
                        this.rowGroupMetadata[value].size++;
                    else
                        this.rowGroupMetadata[value] = { index: i, size: 1 };
                }
            }
        }
    };
    LinkCodeComponent.prototype.onSort = function () {
        this.updateRowGroupMetaData();
    };
    LinkCodeComponent.prototype.editcode = function (event, popup, res) {
        this.modalData = res;
        this.load_addrlist_selected_cust();
        this.get_addrlist_without_cust();
        this.modal = this.modalService.open(popup, { backdrop: 'static', keyboard: false });
    };
    LinkCodeComponent.prototype.editdelivery = function (event, popup, res) {
        this.delivery_data = res;
        this.modal = this.modalService.open(popup, { backdrop: 'static', keyboard: false });
        this.delivery_c = res.name;
        this.delivery_n = res.c_name;
        this.delivery_add = res.address;
        this.delivery_add_province = res.province;
        this.delivery_add_district = res.district;
        this.delivery_add_subdistrict = res.subdistrict;
        this.delivery_add_postalcode = res.postalcode;
        this.delivery_email = res.mail;
        this.delivery_email_update = this.delivery_email.map(function (obj) {
            return { email: obj };
        });
        this.delivery_cc = res.cc;
        this.delivery_cc_update = this.delivery_cc.map(function (obj) {
            return { cc: obj };
        });
        this.delivery_tel = res.tel;
        this.delivery_tel_update = this.delivery_tel.map(function (obj) {
            return { tel: obj };
        });
    };
    LinkCodeComponent.prototype.AddfelidEmail = function () {
        this.keep_email.push({ email: '' });
    };
    LinkCodeComponent.prototype.AddfelidCC = function () {
        this.keep_cc.push({ cc: '' });
    };
    LinkCodeComponent.prototype.AddfelidTel = function () {
        this.keep_tel.push({ tel: '' });
    };
    LinkCodeComponent.prototype.get_addrlist_without_cust = function () {
        var _this = this;
        this.delivery_c = null;
        this.delivery_n = null;
        this.delivery_add = null;
        this.delivery_email = null;
        this.delivery_tel = null;
        this.delivery_cc = null;
        this.delivery_add_district = null;
        this.delivery_add_postalcode = null;
        this.delivery_add_province = null;
        this.delivery_add_subdistrict = null;
        this.addrlist_without_cust = [];
        this.apiService.getDeliveryList().subscribe(function (result) {
            _.forEach(result, function (obj) {
                if (obj.d_custcode === null) {
                    _this.addrlist_without_cust.push({
                        label: obj.d_code,
                        name: obj.d_name,
                        address: obj.d_address,
                        email: obj.d_email_list,
                        cc: obj.d_cc_list,
                        tel: obj.d_tel_list,
                        value: obj.id
                    });
                }
            });
        });
    };
    LinkCodeComponent.prototype.load_Delivery = function (event, data, rowIndex) {
        var _this = this;
        this.tempdataload_Delivery = data;
        this.tempindex_Delivery = rowIndex;
        var params = new HttpParams();
        params = params.append('d_custcode', data.value);
        if (this.searchdelivery) {
            params = params.append('search', this.searchdelivery);
        }
        var dcTemp = [];
        // this.data = data;
        this.apiService.getDeliveryList(params).subscribe(function (result) {
            result = _.orderBy(result, ['d_code'], ['asc']);
            _.forEach(result, function (obj) {
                dcTemp.push({
                    name: obj.d_code,
                    id: obj.id,
                    c_name: obj.d_name,
                    custcode: obj.d_custcode,
                    address: obj.d_address,
                    subdistrict: obj.d_subdistrict,
                    province: obj.d_province,
                    district: obj.d_district,
                    postalcode: obj.d_postalcode,
                    mail: obj.d_email_list,
                    cc: obj.d_cc_list,
                    tel: obj.d_tel_list
                });
            });
            _this.cust_list[rowIndex]['delivery'] = dcTemp;
        });
    };
    LinkCodeComponent.prototype.load_addrlist_selected_cust = function () {
        var _this = this;
        this.addrlist_of_selected_cust = [];
        var params = new HttpParams()
            .set('d_custcode', this.modalData.value);
        this.apiService.getDeliveryList(params).subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.addrlist_of_selected_cust.push({
                    label: obj.d_code,
                    name: obj.d_name,
                    address: obj.d_address,
                    province: obj.d_province,
                    district: obj.d_district,
                    subdistrict: obj.d_subdistrict,
                    postalcode: obj.d_postalcode,
                    email: obj.d_email_list,
                    cc: obj.d_cc_list,
                    tel: obj.d_tel_list,
                    id: obj.id,
                    value: obj.d_custcode
                });
            });
        });
    };
    LinkCodeComponent.prototype.revertBack = function () {
        this.delivery_email_update = [];
        this.delivery_cc_update = [];
        this.delivery_tel_update = [];
        this.delivery_tel = [];
        this.delivery_cc = [];
        this.delivery_email = [];
        this.selectedAddr = null;
        this.keep_email = [];
        this.keep_tel = [];
        this.keep_cc = [];
        this.modal.close();
        this.updateMessage = null;
        this.errorMessage = null;
    };
    LinkCodeComponent.prototype.cleardataEdit = function () {
        this.delivery_email_updatedata = [];
        this.delivery_cc_updatedata = [];
        this.delivery_tel_updatedata = [];
    };
    LinkCodeComponent.prototype.clearSearch = function () {
        this.delivery_email_updatedata = [];
        this.delivery_email_update = [];
        this.delivery_cc_updatedata = [];
        this.delivery_cc_update = [];
        this.delivery_tel_updatedata = [];
        this.delivery_tel_update = [];
        this.loadinput = [];
        this.searchcustcode = null;
        this.searchaddrcode = null;
        this.delivery_c = null;
        this.delivery_n = null;
        this.delivery_add = null;
        this.delivery_email = [];
        this.delivery_tel = [];
        this.delivery_cc = [];
        this.keep_email = [];
        this.keep_tel = [];
        this.keep_cc = [];
        this.cust_list = [];
        this.delivery_add_district = null;
        this.delivery_add_postalcode = null;
        this.delivery_add_province = null;
        this.delivery_add_subdistrict = null;
        this.modal = null;
        this.modalData = null;
        this.searchdelivery = null;
        this.loading_main = false;
        this.currentPage = 1;
        this.loadCustomerList();
        this.loadInput();
    };
    LinkCodeComponent.prototype.search = function () {
        this.loadCustomerList();
    };
    LinkCodeComponent.prototype.pageChanged = function () {
        // const page = new HttpParams().set('page', this.currentPage.toString());
        this.loadCustomerList(this.currentPage);
    };
    LinkCodeComponent.prototype.optionChanged = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadCustomerList();
        // TODO To fix
    };
    LinkCodeComponent.prototype.create_cust = function (event, newpopup) {
        this.newcustname = null;
        this.newcustcode = null;
        this.newcontactname = null;
        this.modal = this.modalService.open(newpopup, { backdrop: 'static', keyboard: false });
    };
    LinkCodeComponent.prototype.delete_customer = function (event, popup, res) {
        this.deleteCustomer = null;
        this.deleteCustomer = res;
        this.modal = this.modalService.open(popup, { backdrop: 'static', keyboard: false });
    };
    LinkCodeComponent.prototype.confirm_deleteCus = function () {
        var _this = this;
        this.loading_main = true;
        this.apiService.deleteCust(this.deleteCustomer.value).subscribe(function () {
            _this.loadCustomerList();
            _this.loading_main = false;
            _this.modal.close();
        }, function (error) {
            _this.errorMess = error;
            _this.loading_main = false;
            console.log(error);
        });
    };
    LinkCodeComponent.prototype.delete_delivery = function (event, popup, res) {
        this.deleteDelivery = null;
        this.deleteDelivery = res;
        this.modal = this.modalService.open(popup, { backdrop: 'static', keyboard: false });
    };
    LinkCodeComponent.prototype.confirm_deleteDeli = function () {
        var _this = this;
        this.loading_main = true;
        this.apiService.deleteDeli(this.deleteDelivery.id).subscribe(function () {
            _this.loadCustomerList();
            _this.loading_main = false;
            _this.modal.close();
        }, function (error) {
            _this.errorMess = error;
            _this.loading_main = false;
            console.log(error);
        });
    };
    LinkCodeComponent.prototype.delete_email_list = function (index, res) {
        this.delivery_email_update.splice(index, 1);
    };
    LinkCodeComponent.prototype.delete_cc_list = function (index, res) {
        this.delivery_cc_update.splice(index, 1);
    };
    LinkCodeComponent.prototype.delete_tel_list = function (index, res) {
        this.delivery_tel_update.splice(index, 1);
    };
    LinkCodeComponent.prototype.delete_felidEmail = function (index, res) {
        this.keep_email.splice(index, 1);
    };
    LinkCodeComponent.prototype.delete_felidCC = function (index, res) {
        this.keep_cc.splice(index, 1);
    };
    LinkCodeComponent.prototype.delete_felidTel = function (index, res) {
        this.keep_tel.splice(index, 1);
    };
    LinkCodeComponent.prototype.save_new_customer = function () {
        var _this = this;
        this.loading_main = true;
        var data = {
            'c_code': this.newcustcode,
            'c_name': this.newcustname,
            'c_contact_name': this.newcontactname
        };
        this.modal.close();
        this.apiService.postCreateCust(data).subscribe();
        setTimeout(function () {
            _this.loadCustomerList();
            _this.loading_main = false;
            _this.showlist = _this.cust_list;
        }, 2000);
    };
    LinkCodeComponent.prototype.add_cust_on_addrcode = function (res) {
        var _this = this;
        if (this.delivery_c == null) {
            return;
        }
        _.forEach(_.concat(this.delivery_email_update, this.keep_email), function (obj) {
            _this.delivery_email_updatedata.push(obj.email);
        });
        _.forEach(_.concat(this.delivery_cc_update, this.keep_cc), function (obj) {
            _this.delivery_cc_updatedata.push(obj.cc);
        });
        _.forEach(_.concat(this.delivery_tel_update, this.keep_tel), function (obj) {
            _this.delivery_tel_updatedata.push(obj.tel);
        });
        this.loading = true;
        this.loading_main = true;
        var data = {
            'd_code': this.delivery_c,
            'd_name': this.delivery_n,
            'd_address': this.delivery_add,
            'd_province': this.delivery_add_province,
            'd_district': this.delivery_add_district,
            'd_subdistrict': this.delivery_add_subdistrict,
            'd_postalcode': this.delivery_add_postalcode,
            'd_email_list': this.delivery_email_updatedata,
            'd_cc_list': this.delivery_cc_updatedata,
            'd_tel_list': this.delivery_tel_updatedata,
            'd_custcode': res.value
        };
        this.apiService.postAddCustOnDelivery(data).subscribe();
        setTimeout(function () {
            _this.load_addrlist_selected_cust();
            _this.get_addrlist_without_cust();
            _this.loading = false;
            _this.modal.close();
            _this.loading_main = false;
            _this.clearSearch();
        }, 2000);
    };
    LinkCodeComponent.prototype.update_delivery = function (res) {
        var _this = this;
        _.forEach(_.concat(this.delivery_email_update, this.keep_email), function (obj) {
            _this.delivery_email_updatedata.push(obj.email);
        });
        _.forEach(_.concat(this.delivery_cc_update, this.keep_cc), function (obj) {
            _this.delivery_cc_updatedata.push(obj.cc);
        });
        _.forEach(_.concat(this.delivery_tel_update, this.keep_tel), function (obj) {
            _this.delivery_tel_updatedata.push(obj.tel);
        });
        this.loading = true;
        // this.loading_main = true;
        var data = {
            'd_code': this.delivery_c,
            'd_name': this.delivery_n,
            'd_address': this.delivery_add,
            'd_province': this.delivery_add_province,
            'd_district': this.delivery_add_district,
            'd_subdistrict': this.delivery_add_subdistrict,
            'd_postalcode': this.delivery_add_postalcode,
            'd_email_list': this.delivery_email_updatedata,
            'd_cc_list': this.delivery_cc_updatedata,
            'd_tel_list': this.delivery_tel_updatedata,
            'd_custcode': res.custcode,
            'id': res.id
        };
        this.apiService.updategetDeliveryList(data).subscribe();
        setTimeout(function () {
            _this.cleardataEdit();
            _this.loading = false;
            var params = new HttpParams();
            params = params.append('d_custcode', _this.tempdataload_Delivery.value);
            if (_this.searchdelivery) {
                params = params.append('search', _this.searchdelivery);
            }
            var dcTemp = [];
            // this.data = data;
            _this.apiService.getDeliveryList(params).subscribe(function (result) {
                result = _.orderBy(result, ['d_code'], ['asc']);
                _.forEach(result, function (obj) {
                    dcTemp.push({
                        name: obj.d_code,
                        id: obj.id,
                        c_name: obj.d_name,
                        custcode: obj.d_custcode,
                        address: obj.d_address,
                        subdistrict: obj.d_subdistrict,
                        province: obj.d_province,
                        district: obj.d_district,
                        postalcode: obj.d_postalcode,
                        mail: obj.d_email_list,
                        cc: obj.d_cc_list,
                        tel: obj.d_tel_list
                    });
                });
                _this.cust_list[_this.tempindex_Delivery]['delivery'] = dcTemp;
            });
            // this.loading_main = false;
            // this.modal.close();
            // this.clearSearch();
        }, 2000);
    };
    LinkCodeComponent.prototype.exportDownload = function () {
        var _this = this;
        this.apiService.getExportExcel().subscribe(function (obj) {
            console.log(obj);
            var filename = 'download_list_code' + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
        });
    };
    LinkCodeComponent.prototype.create_excel = function (event, newpopup) {
        this.keepexcel = [];
        this.modal = this.modalService.open(newpopup, { backdrop: 'static', keyboard: false });
    };
    LinkCodeComponent.prototype.saveImport = function () {
        var _this = this;
        // this.loading_main = true;
        this.loading = true;
        setTimeout(function () {
            var params = new FormData();
            for (var i = 0; i < _this.keepexcel.length; i++) {
                params.append('file', _this.keepexcel[i], _this.keepexcel[i].name);
                // params.append('file[]', this.keepexcel[i], this.keepexcel[i].name); for many file
            }
            _this.apiService.getImportExcel(params).subscribe(function (obj) {
                console.log(_this.keepexcel);
                // alert(obj.message);
                _this.updateMessage = obj.message;
                _this.errorMessage = null;
            }, function (e) {
                _this.errorMessage = e.error.message;
            });
            _this.loading = false;
            _this.loading_main = false;
            // this.modal.close();
            // this.clearSearch();
        }, 2000);
    };
    LinkCodeComponent.prototype.handleFiles = function (event) {
        if (event.target.files.length > 0) {
            this.keepexcel = [];
            // console.log(event.target.files[0].name);
            for (var _i = 0, _a = event.target.files; _i < _a.length; _i++) {
                var file = _a[_i];
                this.keepexcel.push(file);
            }
            console.log(this.keepexcel);
        }
    };
    return LinkCodeComponent;
}());
export { LinkCodeComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/link-code/link-code.component.ts.pre-build-optimizer.js